// extracted by mini-css-extract-plugin
export default {"footer":"footer__kmcya","wrapper":"wrapper__wIrcg","links":"links__W8NJX","brand":"brand__oy-EG","social":"social__9rr50","legal":"legal__piyD1"};